/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxWpm: NonNullable<unknown> }} Error_Nav_Wpm_ExceedsInputs */

const en_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM exceeds maximum set rate (${i?.maxWpm}).`)
};

const fr_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le WPM depasse le taux maximal defini (${i?.maxWpm}).`)
};

const de_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM überschreitet die maximal eingestellte Rate (${i?.maxWpm}).`)
};

const it_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il WPM supera la velocità massima impostata (${i?.maxWpm}).`)
};

const ru_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Скорость печати в словах превышает максимально установленную скорость (${i?.maxWpm}).`)
};

const es_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM excede la velocidad máxima establecida (${i?.maxWpm}).`)
};

const zh_cn2_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM 超过最大设定速率 (${i?.maxWpm})。`)
};

const ja_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM が最大設定速度 (${i?.maxWpm}) を超えています。`)
};

const hi_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM अधिकतम निर्धारित दर (${i?.maxWpm}) से अधिक है।`)
};

const pt_pt2_error_nav_wpm_exceeds = /** @type {(inputs: Error_Nav_Wpm_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM excede a taxa máxima definida (${i?.maxWpm}).`)
};

/**
* | output |
* | --- |
* | "WPM exceeds maximum set rate ({maxWpm})." |
*
* @param {Error_Nav_Wpm_ExceedsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_wpm_exceeds = /** @type {((inputs: Error_Nav_Wpm_ExceedsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Wpm_ExceedsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_wpm_exceeds(inputs)
	if (locale === "de") return de_error_nav_wpm_exceeds(inputs)
	if (locale === "it") return it_error_nav_wpm_exceeds(inputs)
	if (locale === "ru") return ru_error_nav_wpm_exceeds(inputs)
	if (locale === "es") return es_error_nav_wpm_exceeds(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_wpm_exceeds(inputs)
	if (locale === "ja") return ja_error_nav_wpm_exceeds(inputs)
	if (locale === "hi") return hi_error_nav_wpm_exceeds(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_wpm_exceeds(inputs)
	return en_error_nav_wpm_exceeds(inputs)
});